import AddDevelopersPage from "../../../component/users/developers/AddDevelopersPage"

 
 
function EditUserDeveloper() {
  return (
    <div className="page-body"><AddDevelopersPage/></div>
  )
}

export default EditUserDeveloper